export class HttpLoginRequest {
  public userLogin: string;
  public dontAskCheckBox = true;
  securityCode: string;

  constructor(jusername: string) {
    this.userLogin = jusername;
  }
}
